<template>
  <div>
    <div
      class="modal fade"
      id="modal-feedback-interact"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.handlingFeedback.title") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15">
                <div class="row">
                  <div class="col-ms-6 col-md-6 col-lg-6">
                    <p>
                      <label for="">{{ $t("feedback.apartmentCode") }}: </label>
                      {{ feedbackData && feedbackData.apartmentCode }}
                    </p>
                  </div>
                  <div class="col-ms-6 col-md-6 col-lg-6">
                    <p>
                      <label for="">{{ $t("feedback.customerName") }}: </label>
                      {{ feedbackData && feedbackData.customerName }}
                    </p>
                  </div>
                  <div class="col-ms-6 col-md-6 col-lg-6">
                    <p>
                      <label for="">{{ $t("customer.email") }}: </label>
                      {{ feedbackData && feedbackData.customerEmail }}
                    </p>
                  </div>
                  <div class="col-ms-6 col-md-6 col-lg-6">
                    <p>
                      <label for="">{{ $t("customer.phone") }}: </label>
                      {{ feedbackData && feedbackData.customerPhone }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15">
                <p>
                  <label for="">{{ $t("case.casetitle") }}: </label>
                  {{ feedbackData && feedbackData.feedbackTitle }}
                </p>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15">
                <div class="form-group">
                  <label for="">{{ $t("feedback.content") }}: </label>
                  <span style="white-space: pre-wrap;">{{
                    feedbackData && feedbackData.content
                  }}</span>
                </div>
              </div>
              <div
                class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15"
                v-if="feedbackData.status !== feedbackStatusEnum.CREATE"
              >
                <div class="form-group">
                  <label for=""
                    >{{ $t("feedback.customerCareContent") }}:
                  </label>
                  <span style="white-space: pre-wrap;">{{
                    feedbackData && feedbackData.customerCareContent
                  }}</span>
                  <!-- <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="5"
                    class="form-control"
                    v-model="feedbackData.customerCareContent"
                  ></textarea> -->
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{ $t("feedback.processor") }}</label>
                      <!-- <v-select
                        class="clear"
                        :options="departmentList"
                        :reduce="data => data.id"
                        label="name"
                        v-model="feedbackData.departmentId"
                        :placeholder="$t('feedback.processor')"
                        disabled
                      >
                        <template v-slot:option="option">
                          {{ option.name }}
                        </template>
                      </v-select> -->
                      <span 
                        class="form-control disable-input-background" 
                        :title="feedbackData.departmentName"
                      >
                        {{ feedbackData.departmentName }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="!getPrivilegeRole(privilegeRoleEnum.RECEPTION)"
                  >
                    <div class="form-group">
                      <label>{{ $t("case.assignto") }}</label>
                      <!-- <v-select
                        class="clear"
                        :options="staffs"
                        v-model="feedbackData.assignTo"
                        :reduce="data => data.value"
                        :getOptionLabel="option => $t(option.full_name)"
                        :filter="onSearchUserVueSelect"
                        :placeholder="$t('case.assignto')"
                        disabled
                      >
                        <template #list-header>
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">
                                  {{ $t("customer.fullname") }}
                                </th>
                                <th scope="col">{{ $t("customer.email") }}</th>
                              </tr>
                            </thead>
                          </table>
                        </template>
                        <template v-slot:option="option">
                          <div
                            style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                          >
                            <div style="width: 50%; word-break: break-all;">
                              {{ $t(option.full_name) }}
                            </div>
                            <div style="width: 50%">
                              {{ $t(option.email) }}
                            </div>
                          </div>
                        </template>
                      </v-select> -->
                      <span
                        class="form-control disable-input-background" 
                        :title="feedbackData.assignToName"
                      >
                        {{ feedbackData.assignToName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15">
                <div class="form-group">
                  <div class="pull-left">
                    <button
                      v-if="
                        feedbackData.status !== feedbackStatusEnum.CREATE &&
                          getPrivilegeRole(privilegeRoleEnum.RECEPTION)
                      "
                      type="button"
                      class="btn btn-primary btn-sm pull-left"
                      style="margin-right: 10px"
                      @click="onClickUpdateCustomerCareContent()"
                    >
                      {{ $t("feedback.updateCustomerCareContent") }}
                    </button>
                    <button
                      v-if="feedbackData.status !== feedbackStatusEnum.CREATE"
                      type="button"
                      class="btn btn-info btn-sm pull-left"
                      style="margin-right: 10px"
                      @click="onShowTechnicalComment()"
                    >
                      {{ $t("common.comment") }}
                    </button>
                    <button
                      v-if="feedbackData.status !== feedbackStatusEnum.CREATE"
                      type="button"
                      class="btn btn-primary btn-sm pull-left"
                      @click="onShowAddTechnicalComment()"
                    >
                      {{ $t("feedback.addComment") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div>
              <!-- privilege is reception -->
              <div
                v-if="getPrivilegeRole(privilegeRoleEnum.RECEPTION)"
                class="pull-right"
              >
                <button
                  v-if="feedbackData.status !== feedbackStatusEnum.CREATE"
                  type="button"
                  class="btn btn-default btn-sm pull-left"
                  style="margin-right: 10px"
                  @click="onUpdateFeedbackProcessor(feedbackData.departmentId)"
                >
                  <i class="glyphicon glyphicon-wrench"></i>
                  {{ $t("feedback.updateProcessor") }}
                </button>
                <button
                  v-if="feedbackData.status === feedbackStatusEnum.CREATE"
                  type="button"
                  class="btn btn-primary btn-sm pull-left"
                  style="margin-right: 10px"
                  @click="
                    onShowUpdateFeedbackStatus(feedbackStatusEnum.RECEIVED, false)
                  "
                >
                  {{ $t("feedback.statusList.receive") }}
                </button>
                <button
                  v-if="feedbackData.status !== feedbackStatusEnum.CREATE"
                  type="button"
                  class="btn btn-success btn-sm pull-left"
                  @click="onShowUpdateFeedbackStatus(feedbackStatusEnum.DONE, true)"
                >
                  {{ $t("feedback.statusList.done") }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm pull-left"
                  @click="onClickCancel(feedbackStatusEnum.CANCELED)"
                >
                  {{ $t("feedback.statusList.cancel") }}
                </button>
              </div>
              <!-- is assigner action -->
              <div
                v-if="
                  feedbackData.assignTo === GET_ACCOUNT_DATA.id ||
                    isDepartmentManager
                "
                class="pull-right"
              >
                <button
                  v-if="isDepartmentManager && feedbackData.status !== feedbackStatusEnum.CREATE"
                  type="button"
                  class="btn btn-default btn-sm pull-left"
                  style="margin-right: 10px"
                  @click="onUpdateFeedbackAssigner(feedbackData.assignTo)"
                >
                  <i class="glyphicon glyphicon-user"></i>
                  {{ $t("feedback.updatePersonHandle") }}
                </button>
                <button
                  v-if="(feedbackData.status === feedbackStatusEnum.RECEIVED
                    || feedbackData.status === feedbackStatusEnum.IN_PROGRESS)
                    && (feedbackData.assignTo === GET_ACCOUNT_DATA.id)
                  "
                  type="button"
                  class="btn btn-primary btn-sm pull-left"
                  style="margin-right: 10px"
                  @click="
                    onShowUpdateFeedbackStatus(
                      feedbackStatusEnum.IN_PROGRESS_DOING
                    )
                  "
                >
                  {{ $t("feedback.statusList.process") }}
                </button>
                <button
                  v-if="
                    feedbackData.status === feedbackStatusEnum.IN_PROGRESS_DOING
                    && (feedbackData.assignTo === GET_ACCOUNT_DATA.id)
                  "
                  type="button"
                  class="btn btn-success btn-sm pull-left"
                  style="margin-right: 10px"
                  @click="
                    onShowUpdateFeedbackStatus(
                      feedbackStatusEnum.IN_PROGRESS_DONE, true
                    )
                  "
                >
                  {{ $t("feedback.statusList.done") }}
                </button>
                <button
                  v-if="
                    (feedbackData.status === feedbackStatusEnum.RECEIVED ||
                      feedbackData.status ===
                        feedbackStatusEnum.IN_PROGRESS_DOING
                      || feedbackData.status === feedbackStatusEnum.IN_PROGRESS)
                    && (feedbackData.assignTo === GET_ACCOUNT_DATA.id)
                  "
                  type="button"
                  class="btn btn-danger btn-sm pull-left"
                  @click="onClickCancel(feedbackStatusEnum.IN_PROGRESS_CANCEL)"
                >
                  {{ $t("feedback.statusList.cancel") }}
                </button>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <feedback-cancel-action-modal
      ref="feedbackCancelActionModal"
      @callbackFeedbackCancelAction="callbackFeedbackCancelAction"
    />
    <!--  -->
    <feedback-technical-comment ref="feedbackTechnicalComment" />
    <!--  -->
    <feedback-update-assigner-and-processor-modal
      ref="feedbackUpdateAssignerAndProcessorModal"
      @updateAssignerAndProcessor="updateAssignerAndProcessor"
    />

    <!--  -->
    <div
      class="modal fade"
      id="modal-update-feedback-status"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onCloseFeedbackStatusModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(updateFeedbackModalData.title) }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-12"
                v-if="
                  updateFeedbackModalData.status ===
                    feedbackStatusEnum.RECEIVED ||
                    updateFeedbackModalData.status ===
                      feedbackStatusEnum.IN_PROGRESS_DOING ||
                    updateFeedbackModalData.status === feedbackStatusEnum.DONE
                "
              >
                {{ $t(updateFeedbackModalData.content) }}
                <strong>{{ feedbackData.feedbackTitle }}</strong
                >?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseFeedbackStatusModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onUpdateFeedbackStatus"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div
      class="modal fade"
      id="modal-update-feedback-customer-care"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="onHideCustomerCareModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.updateCustomerCareContent") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for=""
                    >{{ $t("feedback.customerCareContent") }}:
                  </label>
                  <span style="white-space: pre-wrap;">{{
                    feedbackData && feedbackData.customerCareContent
                  }}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for=""
                    >{{ $t("feedback.customerCareContentUpdate") }}:
                  </label>
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="5"
                    class="form-control"
                    v-model="customerCareContentUpdate"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onHideCustomerCareModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSaveUpdateCustomerCareContent"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import privilegeRoleEnum from "@/enum/PrivilegeRoleEnum";
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";
//
import FeedbackCancelActionModal from "./FeedbackCancelActionModal";
import FeedbackTechnicalComment from "./FeedbackTechnicalComment";
import FeedbackUpdateAssignerAndProcessorModal from "./FeedbackUpdateAssignerAndProcessorModal";
import LTECoreAlert from "@/components/LTESnackBar.vue";
export default {
  components: {
    loading: Loading,
    FeedbackCancelActionModal,
    FeedbackTechnicalComment,
    FeedbackUpdateAssignerAndProcessorModal,
    "lte-core-alert": LTECoreAlert
  },
  data: () => ({
    isLoading: false,
    feedbackData: {
      id: null,
      feedbackTitle: null,
      content: null,
      customerName: null,
      customerEmail: null,
      customerPhone: null,
      apartmentCode: null,
      departmentId: null,
      departmentName: null,
      assignTo: null,
      assignToName: null,
      status: 1,
      subject: null,
      customerCareContent: null
    },
    departmentList: [],
    staffs: [],
    privilegeRoleEnum: privilegeRoleEnum,
    feedbackStatusEnum: feedbackStatusEnum,
    updateFeedbackModalData: {
      title: "",
      content: "",
      status: null
    },
    customerCareContentUpdate: null,
    isDepartmentManager: false,
    isActionCloseModal: false
  }),
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    getPrivilegeRole: function(privilegeId) {
      return utils.getPrivilegeRole(this.GET_ACCOUNT_DATA, privilegeId);
    },
    onSearchUserVueSelect: function(options, search) {
      let resultSearch = options.filter(
        x =>
          x.full_name.toLowerCase().includes(search.toLowerCase()) ||
          x.email.toLowerCase().includes(search.toLowerCase())
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    onShowModal: function() {
      $("#modal-feedback-interact").modal("show");
    },
    onCloseModal: function() {
      $("#modal-feedback-interact").modal("hide");
    },
    onGetData: async function(feedbackId) {
      this.isLoading = true;
      this.feedbackData.id = feedbackId;
      await this.getFeedbackDetail(feedbackId);
      // await this.getStaffList();
      await this.getDepartmentList();
      await this.onShowModal();
      this.isLoading = false;
    },
    onSave: function() {},
    getFeedbackDetail: function(id) {
      this.GET_FEEDBACK_DETAIL({ id: id }).then(
          function(res) {
            this.isLoading = false;
            let data = res;
            this.feedbackData.feedbackTitle = data.title;
            this.feedbackData.content = data.content;
            this.feedbackData.apartmentCode = utils.getCleanStringValue(data.apartment_data.apartment_name, data.apartment_data.apartment_code);
            this.feedbackData.customerName = data.customer_data.full_name;
            this.feedbackData.customerEmail = data.customer_data.email;
            this.feedbackData.customerPhone = data.customer_data.phone;
            this.feedbackData.feedbackTitle = data.title;
            this.feedbackData.content = data.content;
            this.feedbackData.departmentId = data.department;
            this.feedbackData.assignTo = data.assign_to;
            this.feedbackData.status = data.status;
            this.feedbackData.customerCareContent =
              data.customer_care_description;
            if (!utils.isEmptyString(data.department_data.manager_id)) {
              this.isDepartmentManager = data.department_data.manager_id === this.GET_ACCOUNT_DATA.id ? true : false;
            } else {
              this.isDepartmentManager = false;
            }
            this.feedbackData.departmentName = data.department_data.name
            this.feedbackData.assignToName = data.assign_to_data.full_name
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST();
          }.bind(this)
        );
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST().then(
        function(res) {
          let data = res;
          this.departmentList = [];
          data.forEach(value => {
            let item = {
              id: value.id,
              name: value.name
            };
            this.departmentList.push(item);
          });
        }.bind(this)
      );
    },
    getStaffList: function() {
      let filter = {
        params: {
          feedbackId: this.feedbackData.id
        }
      }
      this.GET_STAFF_LIST(filter).then(
        function(res) {
          let staffList = res.data;
          let staffs = [];
          staffList.forEach(data => {
            let full_name = `${data.last_name} ${data.first_name}`;
            let item = {
              value: data.id,
              full_name: full_name,
              email: data.email
            };
            staffs.push(item);
          });
          this.staffs = staffs;
        }.bind(this)
      );
    },
    onClickCancel: function(statusValue) {
      this.isActionCloseModal = true
      this.$refs.feedbackCancelActionModal.clickCancelFeedback(
        this.feedbackData.id,
        statusValue
      );
    },
    callbackFeedbackCancelAction: function() {
      if (this.isActionCloseModal) {
        this.onCloseModal();
      } else {
        this.getFeedbackDetail(this.feedbackData.id)
      }
      this.$emit("callbackFeedback", true);
    },
    //
    onCloseFeedbackStatusModal: function() {
      $("#modal-update-feedback-status").modal("hide");
    },
    onShowFeedbackStatusModal: function() {
      $("#modal-update-feedback-status").modal("show");
    },
    onShowUpdateFeedbackStatus: function(statusValue, isActionCloseModal) {
      // this.onShowFeedbackStatusModal();
      // this.updateFeedbackModalData.status = statusValue;
      // this.getTitleModal(statusValue);
      this.$refs.feedbackCancelActionModal.clickCancelFeedback(
        this.feedbackData.id,
        statusValue
      );
      this.isActionCloseModal = isActionCloseModal
    },
    getTitleModal: function(statusValue) {
      if (
        statusValue === feedbackStatusEnum.RECEIVED ||
        statusValue === feedbackStatusEnum.IN_PROGRESS_DOING
      ) {
        this.updateFeedbackModalData.title =
          "feedback.handlingFeedback.confirmFeedbackModal.title";
        this.updateFeedbackModalData.content =
          "feedback.handlingFeedback.confirmFeedbackModal.content";
      } else if (statusValue === feedbackStatusEnum.DONE) {
        //
        this.updateFeedbackModalData.title =
          "feedback.handlingFeedback.completeFeedbackModal.title";
        this.updateFeedbackModalData.content =
          "feedback.handlingFeedback.completeFeedbackModal.content";
      } else {
        this.updateFeedbackModalData.title = "";
        this.updateFeedbackModalData.content = "";
      }
    },
    onUpdateFeedbackStatus: function() {
      let data = {
        id: this.feedbackData.id,
        status: this.updateFeedbackModalData.status,
        departmentId: this.feedbackData.departmentId,
        assignToId: this.feedbackData.assignTo
      };
      this.isLoading = true;
      this.POST_FEEDBACK_STATUS(data)
        .then(
          function() {
            this.isLoading = false;
            this.onCloseFeedbackStatusModal();
            this.callbackFeedbackCancelAction();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            this.showError(mess);
            this.isLoading = false;
          }.bind(this)
        );
    },
    // On Show Technical Comment
    onShowTechnicalComment: function() {
      this.$refs.feedbackTechnicalComment.onGetData(this.feedbackData.id);
    },
    // customer care
    onHideCustomerCareModal: function() {
      $("#modal-update-feedback-customer-care").modal("hide");
      this.onShowModal();
    },
    onShowCustomerCareModal: function() {
      $("#modal-update-feedback-customer-care").modal("show");
    },
    onClickUpdateCustomerCareContent: function() {
      this.onShowCustomerCareModal();
      this.customerCareContentUpdate = null;
    },
    onSaveUpdateCustomerCareContent: function() {
      if (utils.isEmptyString(this.customerCareContentUpdate)) {
        this.showError(this.$t("feedback.customerCareContentUpdate"));
      } else {
        let data = {
          id: this.feedbackData.id,
          content: this.customerCareContentUpdate
        };
        this.UPDATE_FEEDBACK_CUSTOMER_CARE_DESCRIPTION(data)
          .then(
            function() {
              this.isLoading = false;
              this.onHideCustomerCareModal();
              this.getFeedbackDetail(this.feedbackData.id);
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              let mess = error.response.data.message;
              this.showError(mess);
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    onShowAddTechnicalComment: function() {
      this.$refs.feedbackTechnicalComment.onShowAddComment(
        this.feedbackData.id
      );
    },
    // update processor
    onUpdateFeedbackProcessor: function(departmentId) {
      this.$refs.feedbackUpdateAssignerAndProcessorModal.onShowUpdateFeedbackProcessor(
        this.feedbackData.id,
        departmentId
      );
    },
    onUpdateFeedbackAssigner: function(assignTo) {
      this.$refs.feedbackUpdateAssignerAndProcessorModal.onShowUpdateFeedbackAssigner(
        this.feedbackData.id,
        assignTo
      );
    },
    updateAssignerAndProcessor: function() {
      this.getFeedbackDetail(this.feedbackData.id)
      this.$emit("callbackFeedback", true);
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_FEEDBACK_DETAIL",
      "GET_STAFF_LIST",
      "GET_DEPARTMENT_LIST",
      "POST_FEEDBACK_STATUS",
      "UPDATE_FEEDBACK_CUSTOMER_CARE_DESCRIPTION"
    ])
  }
};
</script>
<style lang="scss" scoped>
.disable-input-background {
  background: #e4e7e8;
  cursor: no-drop;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/views/Case/FeedbackInteractModal.vue